module.exports = __webpack_public_path__ + "static/media/THETA.7679986b.svg";